export const CLEAR_EPISODE = 'CLEAR_EPISODE'
export const CLEAR_EPISODES = 'CLEAR_EPISODES'
export const SET_EPISODE_COUNT = 'SET_EPISODE_COUNT'
export const SET_EPISODE_CREATION_KEYS = 'SET_EPISODE_CREATION_KEYS'
export const SET_EPISODE_LIST = 'SET_EPISODE_LIST'
export const SET_CURRENT_EPISODE = 'SET_CURRENT_EPISODE'
export const SET_LAST_EPISODE = 'SET_LAST_EPISODE'
export const SET_TOP_EPISODE = 'SET_TOP_EPISODE'
